export default __webpack_public_path__ + "static/performing-7cace5c192c4f59abfee3d6140e777b3.svg";